const textalignCenter = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
      <g fill="none" fill-rule="evenodd" transform="translate(1 -1)">
        <path class="icon-text-align" stroke="#C9CCCD" stroke-linecap="round" stroke-linejoin="round" d="M.416666667 17.9166667L19.5833333 17.9166667M2.08333333.416666667L17.9166667.416666667M5 2.91666667L15 2.91666667M2.91666667 5.41666667L17.0833333 5.41666667M.416666667 7.91666667L19.5833333 7.91666667M3.75 10.4166667L16.25 10.4166667M5.83333333 12.9166667L14.1666667 12.9166667M3.75 15.4166667L16.25 15.4166667" transform="translate(0 1.667)"/>
        <rect width="20" height="20"/>
      </g>
    </svg>
`;

export default textalignCenter;
